import axios from "axios"
import store from "@/store"
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
})

service.interceptors.request.use(
  config => {
    config.headers = {
      token: store.state.token,
      lang: store.state.lang
    };
    return config;
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
)

service.interceptors.response.use(
  response => {
    if (response.headers["content-type"].indexOf("json") === -1) {
        return response;
    }
    const res = response.data

    if (res.code === -100) {
      if(location.pathname != '/contract' && location.pathname != '/contract_sec' && location.pathname != '/ieo/GPTHUSDT'){
        store.commit('tokenChange', '')
        localStorage.removeItem('pcstore_info')
        router.push({ name: 'login' })
      }
      
    }
    if(res.code === 400){//解决未登录问题
      localStorage.removeItem('pcstore_info')
      localStorage.removeItem('token')
      localStorage.removeItem('email')
      store.state.token = ''
      store.state.email = ''
    }
    if (res.refreshtoken) {
      store.commit('tokenChange', res.refreshtoken)
    }
    return response.data;
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
)

export default service